// Dedicated-company deployment configuration.
//
// For the normal multi-tenant SaaS, leave tenantId empty and the login flow
// resolves the company at runtime. For a dedicated deployment, either set the
// REACT_APP_* environment variables or edit DEFAULT_COMPANY_CONFIG below.
// This is the single public entry point other modules should import.
const env = typeof process !== 'undefined' ? process.env || {} : {};

export const DEFAULT_COMPANY_CONFIG = Object.freeze({
  tenantId: '',
  companyName: '',
  appName: 'Cold Storage Management',
  logoUrl: '',
  faviconUrl: '',
  customDomain: '',
  platformSubdomain: '',
  forceCustomDomain: false,
  branding: {
    loginLogoUrl: '',
    loginBackgroundUrl: '',
    splashLogoUrl: '',
    splashBackgroundUrl: '',
    mobileAppLogoUrl: '',
    mobileLoginLogoUrl: '',
    androidLauncherIconUrl: '',
    iosAppIconUrl: '',
  },
  forceCompanyLogin: false,
  defaultFinancialYear: '',
  apiBaseUrl: '',
  weighbridgeAgentUrl: 'http://127.0.0.1:8765',
  gatePassQrOnly: true,
  offline: {
    enabled: true,
    autoSync: true,
    prefetchOnLogin: true,
    historyRetentionDays: 90,
    imageRetentionDays: 30,
    keepUnsyncedUntilSynced: true,
  },
  enabledModules: [],
  deploymentTag: 'multi-tenant',
});

const boolEnv = (value, fallback = false) => {
  if (value === undefined || value === null || value === '') return fallback;
  return ['true', '1', 'yes', 'on'].includes(String(value).trim().toLowerCase());
};

export const COMPANY_CONFIG = Object.freeze({
  ...DEFAULT_COMPANY_CONFIG,
  tenantId: String(env.REACT_APP_COMPANY_TENANT_ID || DEFAULT_COMPANY_CONFIG.tenantId).trim(),
  companyName: String(env.REACT_APP_COMPANY_NAME || DEFAULT_COMPANY_CONFIG.companyName).trim(),
  appName: String(env.REACT_APP_APP_NAME || DEFAULT_COMPANY_CONFIG.appName).trim(),
  logoUrl: String(env.REACT_APP_COMPANY_LOGO_URL || DEFAULT_COMPANY_CONFIG.logoUrl).trim(),
  faviconUrl: String(env.REACT_APP_COMPANY_FAVICON_URL || DEFAULT_COMPANY_CONFIG.faviconUrl).trim(),
  customDomain: String(env.REACT_APP_COMPANY_CUSTOM_DOMAIN || DEFAULT_COMPANY_CONFIG.customDomain).trim(),
  platformSubdomain: String(env.REACT_APP_COMPANY_SUBDOMAIN || DEFAULT_COMPANY_CONFIG.platformSubdomain).trim(),
  forceCustomDomain: boolEnv(env.REACT_APP_FORCE_CUSTOM_DOMAIN, DEFAULT_COMPANY_CONFIG.forceCustomDomain),
  forceCompanyLogin: boolEnv(env.REACT_APP_FORCE_COMPANY_LOGIN, DEFAULT_COMPANY_CONFIG.forceCompanyLogin),
  defaultFinancialYear: String(env.REACT_APP_DEFAULT_FINANCIAL_YEAR || DEFAULT_COMPANY_CONFIG.defaultFinancialYear).trim(),
  apiBaseUrl: String(env.REACT_APP_API_BASE_URL || DEFAULT_COMPANY_CONFIG.apiBaseUrl).trim().replace(/\/$/, ''),
  weighbridgeAgentUrl: String(env.REACT_APP_WEIGHBRIDGE_AGENT_URL || DEFAULT_COMPANY_CONFIG.weighbridgeAgentUrl).trim().replace(/\/$/, ''),
  gatePassQrOnly: true,
  deploymentTag: String(env.REACT_APP_DEPLOYMENT_TAG || (env.REACT_APP_COMPANY_TENANT_ID ? 'dedicated-company' : 'multi-tenant')).trim(),
});

export const isDedicatedCompanyDeployment = () => Boolean(COMPANY_CONFIG.tenantId);

export const mergeCompanyConfig = (runtime = {}) => ({
  ...runtime,
  deployment: {
    ...COMPANY_CONFIG,
    ...(runtime?.deployment || {}),
  },
});

export default COMPANY_CONFIG;
